import CustomSlider from "@components/CustomSlider";
import { usePoiPointSize } from "@hooks/usePoiPointSize";

/**
 * Renders the point-size slider control for a POI category.
 * Shared between PoiIconSection (ICON pin type) and PoiLogoSection (LOGO pin type).
 *
 * State management and API persistence are handled internally via usePoiPointSize.
 */
const PoiPointSizeSlider = () => {
  const { pointSize, handleSliderChange } = usePoiPointSize();

  return (
    <div className="flex flex-col gap-2">
      <p className="text-base">Select a point size</p>
      <p className="text-sm">Enter a value between 10 and 200</p>
      <div className="mb-4">
        <CustomSlider
          min={10}
          max={200}
          step={1}
          value={pointSize}
          onChange={handleSliderChange}
          showInput={true}
          label="Size"
          isInputOnLeft={true}
        />
      </div>
    </div>
  );
};

export default PoiPointSizeSlider;
